<!--

    Copyright © Siemens 2026

-->
<ix-application>
    <ix-application-header name="Publishing Console">
        <div slot="logo">
            <logo />
        </div>
        <div class="header-info">
            <div class="environment-info">
                <ix-typography textColor="soft" format="label">Environment:</ix-typography>
                <ix-typography format="h5">{{ userService.environment() || 'Unknown' }}</ix-typography>
            </div>
            <div class="role-info">
                <ix-typography textColor="soft" format="label">Role:</ix-typography>
                <ix-typography format="h5">{{ userService.role() }}</ix-typography>
            </div>
        </div>
        <ix-avatar [username]="userName">
            @if (userService.isAuthenticated()) {
                <logout-modal></logout-modal>
            } @else {
                <ix-dropdown-item label="Log In" icon="log-in" (click)="login()"></ix-dropdown-item>
            }
        </ix-avatar>
    </ix-application-header>

    <ix-menu enable-toggle-theme="true">
        <!-- Home: landing page with navigation cards -->
        <ix-menu-item
            home-tab
            icon="home"
            [routerLink]="'/'"
            [active]="isActivePage('')"
        >Home</ix-menu-item>

        <!-- Publishing: Software, Revisions, Artifacts — visible to all authenticated roles -->
        @if (userService.isAuthenticated()) {
            <ix-menu-item
                icon="upload"
                [routerLink]="'/publishing'"
                [active]="isActivePage('publishing')"
            >Publishing</ix-menu-item>
        }

        <!-- Access Management: Authorities & Grants — visible to MANAGER and ADMIN only -->
        @if (isManagerOrAdmin()) {
            <ix-menu-item
                icon="key"
                [routerLink]="'/access-management'"
                [active]="isActivePage('access-management')"
            >Access Management</ix-menu-item>
        }
    </ix-menu>

    <div class="app-route-content">
        <app-breadcrumb />
        <router-outlet />
    </div>
    <footer class="app-footer" slot="bottom">
        <span>Copyright (C) Siemens 2025 - 2026</span>
        <nav aria-label="Siemens legal information">
            <a href="http://www.siemens.com/corporate-information">Corporate Information</a>
            <a href="http://www.siemens.com/privacy">Privacy Policy</a>
            <a href="http://www.siemens.com/corp/en/index/terms_of_use.htm">Terms of Use</a>
        </nav>
    </footer>
</ix-application>
